import { RowWithParts, EdgeSeatsNumbers } from '../../../types';

export const getEdgeSeatsNumbers = (row: RowWithParts): EdgeSeatsNumbers => {
	const existentSeats = row?.seats?.filter(seat => seat.isExistent && !seat.isAisle) ?? [];
	const edgeSeatsNumbers: EdgeSeatsNumbers = new Map();

	if (existentSeats.length <= 1) {
		return edgeSeatsNumbers;
	}

	const firstSeatNumber = existentSeats[0].number;
	const lastSeatNumber = existentSeats[existentSeats.length - 1].number;

	edgeSeatsNumbers.set(firstSeatNumber, 'first');
	edgeSeatsNumbers.set(lastSeatNumber, 'last');

	return edgeSeatsNumbers;
};

export const getCollapsedSeatsNumbers = (row: RowWithParts): Set<string> => {
	const seats = row?.seats ?? [];
	const collapsedSeatsNumbers = new Set<string>();

	seats.forEach((seat, index) => {
		if (seat.isExistent || seat.isAisle) {
			return;
		}

		const hasExistentBefore = seats.slice(0, index).some(prevSeat => prevSeat.isExistent);
		const hasExistentAfter = seats.slice(index + 1).some(nextSeat => nextSeat.isExistent);

		if (hasExistentBefore && hasExistentAfter) {
			collapsedSeatsNumbers.add(seat.number);
		}
	});

	return collapsedSeatsNumbers;
};
